import React from 'react';
import {Popover, Space, Spin, Tooltip} from 'antd';
import classNames from 'classnames';
import styles from './index.less';

interface ColumnProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  loading?: boolean;
  children?: React.ReactNode;
}

export const CascaderColumn: React.FC<ColumnProps> = ({ icon, title, loading, children }) => (
  <div className={styles.column}>
    <Space className={styles.columnTitle}>
      {icon}
      <span>{title}</span>
    </Space>
    <div className={styles.optionsContainer}>
      {loading ? (
        <div className={styles.spinnerWrapper}>
          <Spin size="small" />
        </div>
      ) : (
        children
      )}
    </div>
  </div>
);

interface OptionProps {
  selected?: boolean;
  selectedAgent?: boolean;
  tooltip?: string;
  /** Richer hover card (e.g. an agent's overview); shown after `hoverDelay` seconds. */
  popover?: React.ReactNode;
  /** Seconds before the popover shows, so sweeping across the list doesn't flash it. */
  hoverDelay?: number;
  testid?: string;
  onClick?: () => void;
  suffix?: React.ReactNode;
  children: React.ReactNode;
}

export const CascaderOption: React.FC<OptionProps> = ({
  selected,
  selectedAgent,
  tooltip,
  popover,
  hoverDelay,
  onClick,
  suffix,
  testid,
  children,
}) => {
  const el = (
    <div
      data-testid={testid}
      className={classNames(styles.option, {
        [styles.selected]: selected && !selectedAgent,
        [styles.selectedAgent]: selectedAgent,
      })}
      onClick={onClick}
    >
      <div className={styles.optionContent}>{children}</div>
      {suffix}
    </div>
  );

  if (popover) {
    return (
      // Above the cascader dropdown it opens from.
      <Popover placement="right" content={popover} mouseEnterDelay={hoverDelay} zIndex={1100} arrow={false}>
        {el}
      </Popover>
    );
  }

  return tooltip ? (
    <Tooltip placement="topLeft" title={tooltip}>
      {el}
    </Tooltip>
  ) : (
    el
  );
};
